export enum AccountStatus {
    CreditMessage = 'Credit Message',
    Normal = 'Normal',
    OnHold = 'On Hold',
}